<template>
    <h1 class="text--28px text-primary mb-3 d-none d-lg-block">
        {{ title }}
    </h1>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        required: true
    }
});
</script>
